import { render, staticRenderFns } from "./PayerEdit.vue?vue&type=template&id=2679153a&scoped=true&"
import script from "./PayerEdit.vue?vue&type=script&lang=js&"
export * from "./PayerEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2679153a",
  null
  
)

export default component.exports